import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 공통 BreadCrumb 컴포넌트
 * - Home 링크: rmVars.homeUrl
 * - 리스트 페이지: Home > Current
 * - 상세 페이지: Home > Parent(button) > Current
 */
export default function PageBreadcrumb({
  current,
  parent,
  parentTo,
  hideOnMobile = false,
}) {
  const navigate = useNavigate();
  const wrapperClass = hideOnMobile
    ? 'bread hidden mb-[27px] text-[#8D9AAF] text-[13px] items-center gap-1 lg:flex lg:mb-[20px] lg:items-start'
    : 'bread mb-[27px] text-[#8D9AAF] text-[13px] flex items-center gap-1 lg:mb-[20px] lg:items-start';

  const handleParentClick = (e) => {
    try {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
    } catch { }
    if (!parentTo) return;
    try {
      navigate(parentTo);
    } catch {
      window.location.href = parentTo;
    }
  };

  return (
    <div className={wrapperClass}>
      <a href={rmVars.homeUrl} className="flex items-center gap-[2px] shrink-0">
        <img src={`${rmVars.themeUrl}images/home-ico.png`} className="w-[13px]" alt="home" />
        Home
      </a>

      <img
        src={`${rmVars.themeUrl}images/chevron_right_8D9AAF.png`}
        className="w-[12px] shrink-0 lg:translate-y-[4px]"
        alt="right"
      />

      {parent && parentTo && (
        <>
          <button
            type="button"
            className="shrink-0 bg-transparent border-none p-0 cursor-pointer"
            onClick={handleParentClick}
          >
            {parent}
          </button>

          <img
            src={`${rmVars.themeUrl}images/chevron_right_8D9AAF.png`}
            className="w-[12px] shrink-0 lg:translate-y-[4px]"
            alt="right"
          />
        </>
      )}

      <span className="current font-bold truncate min-w-0">{current}</span>
    </div>
  );
}
